import {
  Injectable
} from '@angular/core';
import {
  BsModalService,
  BsModalRef
} from 'ngx-bootstrap/modal';
import {
  FilePreviewComponent
} from '../../../app/application/file-preview/file-preview.component';
import { InspectionFormComponent } from '../../inspection/inspection-form/inspection-form.component';
import { InspectionInfoDetail } from '../../models/ApplicationDetail';
import {
  AccountService
} from '../../services/account.service'

@Injectable({
  providedIn: 'root'
})
export class PreviewModalService {

  bsModalRef: BsModalRef;
  public showDownloadButton: boolean;

  constructor(private modalService: BsModalService, private accService: AccountService) {}

  /** This function is used to open a modal with a pdf data from the back-end*/
  /** @modalUrl - the api url to fetch the pdf file*/
  /** @modalName - the title of the modal*/
  public openModal(modalUrl: string, modalName: string, showDownloadButton: boolean) {
    const initialState = {
      inputUrl: modalUrl,
      title: modalName,
      showDownloadButton: showDownloadButton
    };
    this.bsModalRef = this.modalService.show(FilePreviewComponent, {
      initialState,
      class: 'modal-lg',
      backdrop: 'static',
      keyboard: false
    }, );
  }

  public openModalFile(file: any, modalName: string, showDownloadButton: boolean) {

    console.log('Preview modal called with file');

    const initialState = {
      file: file,
      title: modalName,
      showDownloadButton: showDownloadButton
    };

    this.bsModalRef = this.modalService.show(FilePreviewComponent, {
      initialState,
      class: 'modal-lg',
      backdrop: 'static',
      keyboard: false
    }, );
  }


  public openModalCertificate(url: any, modalName: string, appID:number, showDownloadButton:boolean,isDirector:boolean) {

    console.log('Preview modal called with file');

    let initialState:any;
    
    initialState = {
        inputUrl: url,
        title: modalName,
        showDownloadButton: showDownloadButton,
        isUserDirector:isDirector,
        isDocumentCertificate: true,
        appID:appID
    };
   
    this.bsModalRef = this.modalService.show(FilePreviewComponent, {
      initialState,
      class: 'modal-lg',
      backdrop: 'static',
      keyboard: false
    }, );
  }
}
